export const SERVICES = [
  {
    id: "pictures",
    name: "Assembly and Installs",
    tagline: "Picture hanging, furniture assembly, new shelving & more",
    price: "$85/hr",
    duration: "30–90 min",
    image:
      "https://images.unsplash.com/photo-1513519245088-0e12902e5a38?fm=jpg&q=80&w=1200&auto=format&fit=crop",
    features: ["Picture hanging, mirrors & gallery walls", "Furniture assembly — beds, dressers, desks", "New shelving, anchored into studs", "Other installs — just ask"],
  },
  {
    id: "painting",
    name: "Light Painting",
    tagline: "Touch-ups, accent walls & trim paint",
    price: "$85/hr",
    duration: "2–6 hrs",
    image:
      "https://images.unsplash.com/photo-1511822148790-e7b58ba14c72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2lhbiUyMGZpeCUyMGxpZ2h0JTIwcGFpbnRpbmclMjBob3VzZSUyMHdhbGwlMjBjbGVhbmluZyUyMHNlcnZpY2UlMjB3b3JrZXJ8ZW58MHx8fHwxNzg2NTYxNzU4fDA&ixlib=rb-4.1.0&q=85",
    features: ["Touch-ups & accent walls", "Trim & door painting", "Clean lines, no drips"],
  },
  {
    id: "doors",
    name: "Door Fixing",
    tagline: "Hinges, latches & alignment sorted",
    price: "$85/hr",
    duration: "2-hr minimum (bundle small fixes)",
    image:
      "https://images.unsplash.com/photo-1603673298820-40d77252226d?fm=jpg&q=80&w=1200&auto=format&fit=crop",
    features: ["Squeaks & sticking", "Latch & strike alignment", "Hinge replacement", "Add a door", "Remove a door", "Weather stripping redone"],
  },
  {
    id: "sheetrock",
    name: "Dustless Sheetrock Repair",
    tagline: "Holes, cracks & water damage patched smooth — without the dust storm",
    price: "$85/hr",
    duration: "1–3 hrs",
    video: "/sheetrock-dustless.mp4",
    videoPoster: "/sheetrock-dustless-poster.jpg",
    image:
      "https://images.unsplash.com/photo-1768839725085-829e6ac7ac26?fm=jpg&q=80&w=1200&auto=format&fit=crop",
    features: ["Hole & crack patching", "Texture matching", "Primed, ready to finish or finished and painted"],
  },
  {
    id: "trim",
    name: "Wood Trim Replacement",
    tagline: "Damaged baseboards & casing swapped clean",
    price: "$85/hr",
    duration: "1–3 hrs",
    image:
      "/service-trim-bryan-v3.jpg",
    features: ["Baseboard & casing", "Tight coped corners", "Caulked & paint-ready"],
  },
  {
    id: "mounting",
    name: "Mounting Anything",
    tagline: "TVs, grab bars, blinds & heavy gear",
    price: "$85/hr",
    duration: "30–90 min",
    image: "/work-blinds.jpg",
    features: ["TVs & soundbars", "Grab bars & rails", "Blinds & curtain rods"],
  },
  {
    id: "caulking",
    name: "Re-Caulking",
    tagline: "Old, cracked or moldy caulk stripped & redone tight",
    price: "$85/hr",
    duration: "1–3 hrs",
    image:
      "https://images.unsplash.com/photo-1613849925362-38fb4c16ff36?fm=jpg&q=80&w=1200&auto=format&fit=crop",
    features: ["Showers & tubs", "Kitchen & bath sinks and counters", "Windows & exterior doors (weather sealing)", "Baseboard & trim gaps", "Siding & outside gaps"],
  },
  {
    id: "shower-head",
    name: "Shower Head Swaps",
    tagline: "New shower heads & handheld wands, installed leak-free",
    price: "$85/hr",
    duration: "2-hr minimum (bundle small fixes)",
    image:
      "https://images.pexels.com/photos/4194866/pexels-photo-4194866.jpeg?auto=compress&cs=tinysrgb&w=1200",
    features: ["Rain & handheld heads", "Sealed, drip-free threads", "Old head hauled off"],
  },
  {
    id: "tile",
    name: "Tile Work",
    tagline: "Small tile jobs, repairs & floor prep",
    price: "$85/hr",
    duration: "2–6 hrs",
    image:
      "https://images.unsplash.com/photo-1587527901949-ab0341697c1e?fm=jpg&q=80&w=1200&auto=format&fit=crop",
    features: ["Cracked tile replacement", "Old thinset removed, floor prepped", "Grout & edge touch-ups"],
  },
  {
    id: "fans",
    name: "Bathroom Fans & Ducting",
    tagline: "Quiet bath fans, vented outside the right way",
    price: "$85/hr",
    duration: "2–4 hrs",
    image:
      "https://images.unsplash.com/photo-1572081790780-1a7739896259?fm=jpg&q=80&w=1200&auto=format&fit=crop",
    features: ["Replacing old or noisy bath fans", "Fan + light combo units", "New or rerouted ducting to the outside", "Fixing fans that vent into the attic"],
  },
  {
    id: "countertop",
    name: "Cooktop Cutouts",
    tagline: "New cooktop holes in solid surface counters",
    price: "$85/hr",
    duration: "2–3 hrs",
    image:
      "https://images.unsplash.com/photo-1550223026-0d6fd780c560?fm=jpg&q=80&w=1200&auto=format&fit=crop",
    features: ["Precise template cuts", "Solid surface & laminate", "Sealed edges"],
  },
  {
    id: "advocate",
    name: "Contractor Meeting Backup",
    tagline: "Third-party advice at your contractor meeting",
    price: "$85/hr",
    duration: "2-hr minimum (bundle small fixes)",
    image:
      "/advocate-meeting-v2.jpg",
    features: ["I ask the right questions for you", "Spot red flags before you sign", "25 yrs of remodel know-how"],
  },
  {
    id: "lighting",
    name: "Lighting & Ceiling Fans",
    tagline: "LED light strips, bulb swaps & fan installs",
    price: "$85/hr",
    duration: "1–2 hrs",
    image:
      "https://images.unsplash.com/photo-1767203330128-b4c27297f320?fm=jpg&q=80&w=1200&auto=format&fit=crop",
    features: ["LED strip lighting", "Lightbulbs replaced", "Ceiling fan install"],
  },
  {
    id: "punch-list",
    name: "Punch List Rescue",
    tagline: "End-of-project punch lists for remodelers",
    price: "$85/hr",
    duration: "Half–full day",
    image:
      "/service-punch-bryan.jpg",
    imagePosition: "center 22%",
    features: ["Multi-trade finish work", "Trim, hardware & fixture installs", "Hand off the list — I close it out"],
  },
  {
    id: "leak-repair",
    name: "Leak & Drip Repair",
    tagline: "Small plumbing leaks, drips & running toilets",
    price: "$85/hr",
    duration: "1–2 hrs",
    image:
      "https://images.unsplash.com/photo-1637939157381-fe0d03755314?fm=jpg&q=80&w=1200&auto=format&fit=crop",
    features: ["Faucet & fixture drips", "Under-sink leak fixes", "Running toilet repair"],
  },
];

export const TIME_SLOTS = [
  "4:00 – 5:00 PM",
];
// minutes past midnight (Pacific) the estimate window starts — today closes for booking from then
export const ESTIMATE_START_MIN = 16 * 60;

export const MARQUEE_ITEMS = [
  "Same-Week Appointments",
  "Licensed & Insured",
  "Lifetime Workmanship Guarantee",
  "Upfront Flat Pricing",
  "Background-Checked Craftsmen",
  "Repairs & Installs",
];
